import { createI18n } from "vue-i18n";

export type LocaleCode = "en" | "da" | "sv" | "de" | "is" | "no";

const supportedLocales: LocaleCode[] = ["en", "da", "sv", "de", "is", "no"];

const browserLocaleRaw = navigator.language?.split("-")[0]?.toLowerCase();
const browserLocale = supportedLocales.includes(browserLocaleRaw as LocaleCode) ? (browserLocaleRaw as LocaleCode) : "en";

const storedLocale = localStorage.getItem("locale") as LocaleCode | null;

const locale: LocaleCode = storedLocale && supportedLocales.includes(storedLocale) ? storedLocale : browserLocale;

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: "en",
  messages: {
    en: {},
    da: {},
    sv: {},
    de: {},
    is: {},
    no: {},
  },
});

export default i18n;
